import { Common, color } from '@stockbit/ui';
import styled from 'styled-components';

const { Text, Button } = Common;

const Wrapper = styled.div`
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #dadada;
  display: table;
  font-size: 16px;
  height: 100%;
  left: 0;
  margin: auto;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 1000;
`;

const ContentWrapper = styled.div`
  align-items: center;
  background: #fff;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  text-align: center;
  width: 100%;
  overflow: auto;

  animation: fade-in-pulse 0.3s forwards cubic-bezier(0.8, 0.02, 0.45, 0.91);
  transform-origin: bottom center;

  &.ob-discover {
    @media only screen and (max-height: 600px) {
      justify-content: flex-start;
      padding: 48px 0;
    }
  }
`;

const Content = styled.div`
  width: 600px;

  position: relative;
  text-align: center;
  display: table-cell;
  vertical-align: middle;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

const Title = styled(Text).attrs({
  family: 'bold',
  size: '18px',
  mx: 'auto',
  align: 'center',
})`
  span {
    color: ${color.dimgray};
    display: block;
    font-family: ProximaNovaRg;
    font-size: 13px;
    font-weight: normal;
    padding-top: 5px;
  }
`;

const Relative = styled.div`
  position: relative;
`;

const ListWrapper = styled.div`
  height: 480px;
  margin-bottom: 18px;
  overflow-y: auto;
  margin-right: -15px;
  padding-right: 12px;
`;

const ButtonNext = styled(Button).attrs({ type: 'primary' })`
  background-color: ${color.midgray};
  border-color: transparent;
  cursor: pointer;

  :hover,
  :focus {
    background-color: ${color.primary};
  }
`;

export {
  Wrapper,
  Content,
  ContentWrapper,
  Title,
  Relative,
  ListWrapper,
  ButtonNext,
};
